export enum ExternalUserModalBehaviour {
  REOPEN = 'reopen',
}
